import { twMerge } from 'tailwind-merge';

import { FishCatchesIcon } from '../../../../../components/Icons/FishCatchesIcon';
import { Text } from '../../../../../components/Text/Text';

interface IProps {
  className?: string;
}

export const EmptyCatchCardImage = ({ className }: IProps) => {
  return (
    <span
      className={twMerge(
        'bg-twilight flex h-full w-full flex-wrap content-center justify-center rounded-md',
        className,
      )}
    >
      <FishCatchesIcon className="text-lake-fog w-full" size={80} title="fish catches icon" />
      <Text className="text-sea-foam font-semibold">No photo added for this catch</Text>
    </span>
  );
};
